import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Form, Grid, Segment } from 'semantic-ui-react'
import FormEntry from '../../../models/FormEntry'
import Input from '../Inputs/Input'
import { BatteryModel, LightingModel, LightingSubUnit, YesNo } from '../../../utils/FormSelectHelper'
import Select from '../Inputs/Select'
import DatePicker from '../Inputs/DatePicker'
import Checkbox from '../Inputs/Checkbox'
import TableDnD from '../Inputs/TableDnD'
import TextArea from '../Inputs/TextArea'

@observer
class RIEECL000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    changeMenuType: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { changeMenuType } = this.props
    changeMenuType('search', {
      label: 'Rechercher équipement par emplacement',
      enableShowAll: true,
      searchFields: [
        { fieldName: 'emplacement', isFixed: true }
      ]
    })
  }

  render () {
    const { equipment } = this.props

    return (
      <Form>
        <Grid columns={2} celled>
          <Grid.Row>
            <Grid.Column stretched>
              <Segment basic>
                <Form.Group widths='equal'>
                  <Input name='emplacement' formEntry={equipment} label='Emplacement' isFixed />
                </Form.Group>
                <Form.Group widths='equal'>
                  <Select
                    name='uniteDefectueuse' formEntry={equipment} options={YesNo()} defaultValue='oui'
                    label='Unité défectueuse'
                  />
                  <Select
                    name='modele' formEntry={equipment} options={LightingModel()}
                    defaultValue={LightingModel()[0].value} label='Modèle' isFixed
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                  <Select
                    name='interrupteur' formEntry={equipment} options={YesNo()} defaultValue='oui'
                    label='Interrupteur essaie'
                  />
                </Form.Group>
                <Checkbox
                  name='verificationEffectue' formEntry={equipment} label='Vérification effectué'
                />
              </Segment>
            </Grid.Column>
            <Grid.Column stretched>
              <Segment basic>
                <Form.Group widths='equal'>
                  <Select
                    options={BatteryModel()}
                    defaultValue={BatteryModel()[0].value}
                    name='batterie' formEntry={equipment} label='Batterie' isFixed
                  />
                  <Select
                    options={[{ value: '1', text: '1' }, { value: '2', text: '2' }, {
                      value: '4',
                      text: '4'
                    }, { value: '6', text: '6' }, { value: '8', text: '8' }]}
                    defaultValue='1'
                    name='quantite' formEntry={equipment} label='Quantité' isFixed
                  />
                </Form.Group>
                <Form.Group widths='equal'>
                  <DatePicker name='date' formEntry={equipment} label='Date' />
                  <Select
                    name='batterieRemplacer' formEntry={equipment} options={YesNo()} defaultValue='oui'
                    label='Batterie à remplacer'
                  />
                </Form.Group>
                <Select
                  name='chargeurLed' formEntry={equipment} options={YesNo()} defaultValue='oui'
                  label='Fonctionnement chargeur'
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column stretched width={16}>
              <Segment basic>
                <TableDnD
                  totalRowLabel='suTableRows'
                  droppableKey='sousUniteTable'
                  tableProps={{ celled: true }}
                  headers={[{
                    props: { width: 7, textAlign: 'center' },
                    label: 'Modèle'
                  }, {
                    props: { width: 7, textAlign: 'center' },
                    label: 'Sous unité'
                  }]}
                  fields={[
                    {
                      fieldType: Select,
                      props: {
                        name: 'sousuniteModel_',
                        options: LightingSubUnit()
                      }
                    }, {
                      fieldType: Input,
                      props: {
                        name: 'sousunite_'
                      }
                    }
                  ]}
                  formEntry={equipment}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column stretched width={16}>
              <Segment basic>
                <TextArea name='remarque' formEntry={equipment} label='Remarque' />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    )
  }
}

export default RIEECL000
